import { LocalStorageManager } from '../../helper/localStorage'
import { PATH } from '../../constants/router'

export const TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME_SEEN_STORAGE_KEY = 'trafficFineRegistrationManagementFirstTimeSeenUsers'

function getSeenUsersMap() {
  const storedValue = LocalStorageManager.getItem(TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME_SEEN_STORAGE_KEY)

  if (storedValue && typeof storedValue === 'object' && !Array.isArray(storedValue)) {
    return storedValue
  }

  return {}
}

export function getTrafficFineRegistrationManagementUserKey({ phoneNumber } = {}) {
  return String(phoneNumber || 'anonymous')
}

export function hasSeenTrafficFineRegistrationManagementFirstTime(userKey = '') {
  if (!userKey) {
    return false
  }

  const seenUsersMap = getSeenUsersMap()
  return seenUsersMap[userKey] === true
}

export function markTrafficFineRegistrationManagementFirstTimeAsSeen(userKey = '') {
  if (!userKey) {
    return
  }

  const seenUsersMap = getSeenUsersMap()

  if (seenUsersMap[userKey] === true) {
    return
  }

  LocalStorageManager.setItem(TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME_SEEN_STORAGE_KEY, {
    ...seenUsersMap,
    [userKey]: true
  })
}

export function getTrafficFineRegistrationManagementEntryPath({ hasRegisteredVehicle = false, hasSeenFirstTime = false } = {}) {
  return hasRegisteredVehicle || hasSeenFirstTime
    ? PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT
    : PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME
}
